import React, { useState } from 'react';

const ChartModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  return (
    <>
      {/* Chart Icon */}
      <div className="chart-icon" onClick={openModal}>
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 13h2v8H3zm4-8h2v16H7zm4-2h2v18h-2zm4 4h2v14h-2zm4-2h2v16h-2z"/>
        </svg>
      </div>

      {/* Chart Modal */}
      <div className={`chart-modal ${isOpen ? 'open' : ''}`} onClick={handleBackdropClick}>
        <div className="chart-modal-content">
          <div className="chart-close" onClick={closeModal}>
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
            </svg>
          </div>
          <div style={{ width: '800px', height: '500px', maxWidth: '90vw', maxHeight: '80vh' }}>
            <iframe
              src="https://dexscreener.com/solana/5aW63GU53U9iQR5KgyFQq1bK2FymQhwB2qxWdWGepump?embed=1&loadChartSettings=0&trades=0&tabs=0&chartLeftToolbar=0&chartDefaultOnMobile=1&chartTheme=dark&theme=dark&chartStyle=0&chartType=usd&interval=15"
              style={{ width: '100%', height: '100%', border: 'none', borderRadius: '16px' }}
              title="DexScreener Chart"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ChartModal;
